import { SvgIcon } from '../../../components'
import * as React from 'react'
import { useTheme } from '../../../hooks/useTheme'

function PushPin({ size = '18px', sx: customSx, ...props }) {
  const theme = useTheme()

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.pin.background,
        borderRadius: '50%',
        padding: '1px',
        height: '20px',
        width: '20px',
        border: `1.5px solid ${theme.palette.background.paper}`
      }}
    >
      <SvgIcon
        className='push-pin-icon'
        viewBox='0 0 24 24'
        {...props}
        sx={{
          fill: theme.palette.pin.color,
          transform: 'rotate(40deg)',
          fontSize: size,
          flexShrink: 0,
          marginTop: '9px',
          width: size,
          height: size,
          ...customSx
        }}
      >
        <path d='M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354' />
      </SvgIcon>
    </div>
  )
}

const MemoPushPin = React.memo(PushPin)

export default MemoPushPin
